export function toBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () =>
            resolve((reader.result as string).split("base64,").pop()!);
        reader.onerror = (error) => reject(error);
    });
}

// Removed unused export: download(blob, fileName) - see PR #4802 for history
